export const bancos = [
    {
      "codBanco": "001",
      "banco": "Banco do Brasil S.A."
    },
    {
      "codBanco": "003",
      "banco": "Banco da Amazônia S.A."
    },
    {
      "codBanco": "004",
      "banco": "Banco do Nordeste do Brasil S.A."
    },
    {
      "codBanco": "007",
      "banco": "Banco Nacional de Desenvolvimento Econômico e Social BNDES"
    },
    {
      "codBanco": "010",
      "banco": "Credicoamo Crédito Rural Cooperativa"
    },
    {
      "codBanco": "011",
      "banco": "Credit Suisse Hedging-Griffo Corretora de Valores S.A."
    },
    {
      "codBanco": "012",
      "banco": "Banco Inbursa S.A."
    },
    {
      "codBanco": "014",
      "banco": "Natixis Brasil S.A. Banco Múltiplo"
    },
    {
      "codBanco": "015",
      "banco": "UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
    },
    {
      "codBanco": "016",
      "banco": "Coop de Créd. Mútuo dos Despachantes de Trânsito de SC e Rio Grande do Sul"
    },
    {
      "codBanco": "017",
      "banco": "BNY Mellon Banco S.A."
    },
    {
      "codBanco": "018",
      "banco": "Banco Tricury S.A."
    },
    {
      "codBanco": "021",
      "banco": "Banestes S.A. Banco do Estado do Espírito Santo"
    },
    {
      "codBanco": "024",
      "banco": "Banco Bandepe S.A."
    },
    {
      "codBanco": "025",
      "banco": "Banco Alfa S.A."
    },
    {
      "codBanco": "029",
      "banco": "Banco Itaú Consignado S.A."
    },
    {
      "codBanco": "033",
      "banco": "Banco Santander (Brasil) S. A."
    },
    {
      "codBanco": "036",
      "banco": "Banco Bradesco BBI S.A."
    },
    {
      "codBanco": "037",
      "banco": "Banco do Estado do Pará S.A."
    },
    {
      "codBanco": "040",
      "banco": "Banco Cargill S.A."
    },
    {
      "codBanco": "041",
      "banco": "Banco do Estado do Rio Grande do Sul S.A."
    },
    {
      "codBanco": "047",
      "banco": "Banco do Estado de Sergipe S.A."
    },
    {
      "codBanco": "060",
      "banco": "Confidence Corretora de Câmbio S.A."
    },
    {
      "codBanco": "062",
      "banco": "Hipercard Banco Múltiplo S.A."
    },
    {
      "codBanco": "063",
      "banco": "Banco Bradescard S.A."
    },
    {
      "codBanco": "064",
      "banco": "Goldman Sachs do Brasil  Banco Múltiplo S. A."
    },
    {
      "codBanco": "065",
      "banco": "Banco AndBank (Brasil) S.A."
    },
    {
      "codBanco": "066",
      "banco": "Banco Morgan Stanley S. A."
    },
    {
      "codBanco": "069",
      "banco": "Banco Crefisa S.A."
    },
    {
      "codBanco": "070",
      "banco": "Banco de Brasília S.A."
    },
    {
      "codBanco": "074",
      "banco": "Banco J. Safra S.A."
    },
    {
      "codBanco": "075",
      "banco": "Banco ABN Amro S.A."
    },
    {
      "codBanco": "076",
      "banco": "Banco KDB do Brasil S.A."
    },
    {
      "codBanco": "077",
      "banco": "Banco Inter S.A."
    },
    {
      "codBanco": "078",
      "banco": "Haitong Banco de Investimento do Brasil S.A."
    },
    {
      "codBanco": "079",
      "banco": "Banco Original do Agronegócio S.A."
    },
    {
      "codBanco": "080",
      "banco": "BT Corretora de Câmbio Ltda."
    },
    {
      "codBanco": "081",
      "banco": "BBN Banco Brasileiro de Negocios S.A."
    },
    {
      "codBanco": "082",
      "banco": "Banco Topazio S.A."
    },
    {
      "codBanco": "083",
      "banco": "Banco da China Brasil S.A."
    },
    {
      "codBanco": "084",
      "banco": "Uniprime Norte do Paraná - Cooperativa de Crédito Ltda."
    },
    {
      "codBanco": "085",
      "banco": "Cooperativa Central de Crédito Urbano - Cecred"
    },
    {
      "codBanco": "089",
      "banco": "Cooperativa de Crédito Rural da Região da Mogiana"
    },
    {
      "codBanco": "091",
      "banco": "Central de Cooperativas de Economia e Crédito Mútuo do Est RS - Unicred"
    },
    {
      "codBanco": "092",
      "banco": "BRK S.A. Crédito, Financiamento e Investimento"
    },
    {
      "codBanco": "093",
      "banco": "Pólocred Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte"
    },
    {
      "codBanco": "094",
      "banco": "Banco Finaxis S.A."
    },
    {
      "codBanco": "095",
      "banco": "Banco Confidence de Câmbio S.A."
    },
    {
      "codBanco": "096",
      "banco": "Banco BMFBovespa de Serviços de Liquidação e Custódia S/A"
    },
    {
      "codBanco": "097",
      "banco": "Cooperativa Central de Crédito Noroeste Brasileiro Ltda - CentralCredi"
    },
    {
      "codBanco": "098",
      "banco": "Credialiança Cooperativa de Crédito Rural"
    },
    {
      "codBanco": "099",
      "banco": "Uniprime Central – Central Interestadual de Cooperativas de Crédito Ltda."
    },
    {
      "codBanco": "100",
      "banco": "Planner Corretora de Valores S.A."
    },
    {
      "codBanco": "101",
      "banco": "Renascença Distribuidora de Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "102",
      "banco": "XP Investimentos Corretora de Câmbio Títulos e Valores Mobiliários S.A."
    },
    {
      "codBanco": "104",
      "banco": "Caixa Econômica Federal"
    },
    {
      "codBanco": "105",
      "banco": "Lecca Crédito, Financiamento e Investimento S/A"
    },
    {
      "codBanco": "107",
      "banco": "Banco Bocom BBM S.A."
    },
    {
      "codBanco": "108",
      "banco": "PortoCred S.A. Crédito, Financiamento e Investimento"
    },
    {
      "codBanco": "111",
      "banco": "Oliveira Trust Distribuidora de Títulos e Valores Mobiliários S.A."
    },
    {
      "codBanco": "113",
      "banco": "Magliano S.A. Corretora de Cambio e Valores Mobiliarios"
    },
    {
      "codBanco": "114",
      "banco": "Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP"
    },
    {
      "codBanco": "117",
      "banco": "Advanced Corretora de Câmbio Ltda."
    },
    {
      "codBanco": "118",
      "banco": "Standard Chartered Bank (Brasil) S.A. Banco de Investimento"
    },
    {
      "codBanco": "119",
      "banco": "Banco Western Union do Brasil S.A."
    },
    {
      "codBanco": "120",
      "banco": "Banco Rodobens SA"
    },
    {
      "codBanco": "121",
      "banco": "Banco Agibank S.A."
    },
    {
      "codBanco": "122",
      "banco": "Banco Bradesco BERJ S.A."
    },
    {
      "codBanco": "124",
      "banco": "Banco Woori Bank do Brasil S.A."
    },
    {
      "codBanco": "125",
      "banco": "Brasil Plural S.A. Banco Múltiplo"
    },
    {
      "codBanco": "126",
      "banco": "BR Partners Banco de Investimento S.A."
    },
    {
      "codBanco": "127",
      "banco": "Codepe Corretora de Valores e Câmbio S.A."
    },
    {
      "codBanco": "128",
      "banco": "MS Bank S.A. Banco de Câmbio"
    },
    {
      "codBanco": "129",
      "banco": "UBS Brasil Banco de Investimento S.A."
    },
    {
      "codBanco": "130",
      "banco": "Caruana S.A. Sociedade de Crédito, Financiamento e Investimento"
    },
    {
      "codBanco": "131",
      "banco": "Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda."
    },
    {
      "codBanco": "132",
      "banco": "ICBC do Brasil Banco Múltiplo S.A."
    },
    {
      "codBanco": "133",
      "banco": "Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e"
    },
    {
      "codBanco": "134",
      "banco": "BGC Liquidez Distribuidora de Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "135",
      "banco": "Gradual Corretora de Câmbio, Títulos e Valores Mobiliários S.A."
    },
    {
      "codBanco": "136",
      "banco": "Confederação Nacional das Cooperativas Centrais Unicred Ltda – Unicred do Brasil"
    },
    {
      "codBanco": "137",
      "banco": "Multimoney Corretora de Câmbio Ltda"
    },
    {
      "codBanco": "138",
      "banco": "Get Money Corretora de Câmbio S.A."
    },
    {
      "codBanco": "139",
      "banco": "Intesa Sanpaolo Brasil S.A. - Banco Múltiplo"
    },
    {
      "codBanco": "140",
      "banco": "Easynvest - Título Corretora de Valores SA"
    },
    {
      "codBanco": "142",
      "banco": "Broker Brasil Corretora de Câmbio Ltda."
    },
    {
      "codBanco": "143",
      "banco": "Treviso Corretora de Câmbio S.A."
    },
    {
      "codBanco": "144",
      "banco": "Bexs Banco de Câmbio S.A."
    },
    {
      "codBanco": "145",
      "banco": "Levycam - Corretora de Câmbio e Valores Ltda."
    },
    {
      "codBanco": "146",
      "banco": "Guitta Corretora de Câmbio Ltda."
    },
    {
      "codBanco": "149",
      "banco": "Facta Financeira S.A. - Crédito Financiamento e Investimento"
    },
    {
      "codBanco": "157",
      "banco": "ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "159",
      "banco": "Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor"
    },
    {
      "codBanco": "163",
      "banco": "Commerzbank Brasil S.A. - Banco Múltiplo"
    },
    {
      "codBanco": "169",
      "banco": "Banco Olé Bonsucesso Consignado S.A."
    },
    {
      "codBanco": "172",
      "banco": "Albatross Corretora de Câmbio e Valores S.A"
    },
    {
      "codBanco": "173",
      "banco": "BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A."
    },
    {
      "codBanco": "174",
      "banco": "Pernambucanas Financiadora S.A. Crédito, Financiamento e Investimento"
    },
    {
      "codBanco": "177",
      "banco": "Guide Investimentos S.A. Corretora de Valores"
    },
    {
      "codBanco": "180",
      "banco": "CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "182",
      "banco": "Dacasa Financeira S/A - Sociedade de Crédito, Financiamento e Investimento"
    },
    {
      "codBanco": "183",
      "banco": "Socred S.A. - Sociedade de Crédito ao Microempreendedor"
    },
    {
      "codBanco": "184",
      "banco": "Banco Itaú BBA S.A."
    },
    {
      "codBanco": "188",
      "banco": "Ativa Investimentos S.A. Corretora de Títulos Câmbio e Valores"
    },
    {
      "codBanco": "189",
      "banco": "HS Financeira S/A Crédito, Financiamento e Investimentos"
    },
    {
      "codBanco": "190",
      "banco": "Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do Rio"
    },
    {
      "codBanco": "191",
      "banco": "Nova Futura Corretora de Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "194",
      "banco": "Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "196",
      "banco": "Fair Corretora de Câmbio S.A."
    },
    {
      "codBanco": "197",
      "banco": "Stone Pagamentos S.A."
    },
    {
      "codBanco": "204",
      "banco": "Banco Bradesco Cartões S.A."
    },
    {
      "codBanco": "208",
      "banco": "Banco BTG Pactual S.A."
    },
    {
      "codBanco": "212",
      "banco": "Banco Original S.A."
    },
    {
      "codBanco": "213",
      "banco": "Banco Arbi S.A."
    },
    {
      "codBanco": "217",
      "banco": "Banco John Deere S.A."
    },
    {
      "codBanco": "218",
      "banco": "Banco BS2 S.A."
    },
    {
      "codBanco": "222",
      "banco": "Banco Credit Agrícole Brasil S.A."
    },
    {
      "codBanco": "224",
      "banco": "Banco Fibra S.A."
    },
    {
      "codBanco": "233",
      "banco": "Banco Cifra S.A."
    },
    {
      "codBanco": "237",
      "banco": "Banco Bradesco S.A."
    },
    {
      "codBanco": "241",
      "banco": "Banco Clássico S.A."
    },
    {
      "codBanco": "243",
      "banco": "Banco Máxima S.A."
    },
    {
      "codBanco": "246",
      "banco": "Banco ABC Brasil S.A."
    },
    {
      "codBanco": "249",
      "banco": "Banco Investcred Unibanco S.A."
    },
    {
      "codBanco": "250",
      "banco": "BCV - Banco de Crédito e Varejo S/A"
    },
    {
      "codBanco": "253",
      "banco": "Bexs Corretora de Câmbio S/A"
    },
    {
      "codBanco": "254",
      "banco": "Parana Banco S. A."
    },
    {
      "codBanco": "260",
      "banco": "Nu Pagamentos S.A."
    },
    {
      "codBanco": "265",
      "banco": "Banco Fator S.A."
    },
    {
      "codBanco": "266",
      "banco": "Banco Cédula S.A."
    },
    {
      "codBanco": "268",
      "banco": "Barigui Companhia Hipotecária"
    },
    {
      "codBanco": "269",
      "banco": "HSBC Brasil S.A. Banco de Investimento"
    },
    {
      "codBanco": "271",
      "banco": "IB Corretora de Câmbio, Títulos e Valores Mobiliários Ltda."
    },
    {
      "codBanco": "300",
      "banco": "Banco de la Nacion Argentina"
    },
    {
      "codBanco": "318",
      "banco": "Banco BMG S.A."
    },
    {
      "codBanco": "320",
      "banco": "China Construction Bank (Brasil) Banco Múltiplo S/A"
    },
    {
      "codBanco": "336",
      "banco": "Banco C6 S.A – C6 Bank"
    },
    {
      "codBanco": "341",
      "banco": "Itaú Unibanco  S.A."
    },
    {
      "codBanco": "366",
      "banco": "Banco Société Générale Brasil S.A."
    },
    {
      "codBanco": "370",
      "banco": "Banco Mizuho do Brasil S.A."
    },
    {
      "codBanco": "376",
      "banco": "Banco J. P. Morgan S. A."
    },
    {
      "codBanco": "389",
      "banco": "Banco Mercantil do Brasil S.A."
    },
    {
      "codBanco": "394",
      "banco": "Banco Bradesco Financiamentos S.A."
    },
    {
      "codBanco": "399",
      "banco": "Kirton Bank S.A. - Banco Múltiplo"
    },
    {
      "codBanco": "412",
      "banco": "Banco Capital S. A."
    },
    {
      "codBanco": "422",
      "banco": "Banco Safra S.A."
    },
    {
      "codBanco": "456",
      "banco": "Banco MUFG Brasil S.A."
    },
    {
      "codBanco": "464",
      "banco": "Banco Sumitomo Mitsui Brasileiro S.A."
    },
    {
      "codBanco": "473",
      "banco": "Banco Caixa Geral - Brasil S.A."
    },
    {
      "codBanco": "477",
      "banco": "Citibank N.A."
    },
    {
      "codBanco": "479",
      "banco": "Banco ItauBank S.A."
    },
    {
      "codBanco": "487",
      "banco": "Deutsche Bank S.A. - Banco Alemão"
    },
    {
      "codBanco": "488",
      "banco": "JPMorgan Chase Bank, National Association"
    },
    {
      "codBanco": "492",
      "banco": "ING Bank N.V."
    },
    {
      "codBanco": "494",
      "banco": "Banco de La Republica Oriental del Uruguay"
    },
    {
      "codBanco": "495",
      "banco": "Banco de La Provincia de Buenos Aires"
    },
    {
      "codBanco": "505",
      "banco": "Banco Credit Suisse (Brasil) S.A."
    },
    {
      "codBanco": "545",
      "banco": "Senso Corretora de Câmbio e Valores Mobiliários S.A."
    },
    {
      "codBanco": "600",
      "banco": "Banco Luso Brasileiro S.A."
    },
    {
      "codBanco": "604",
      "banco": "Banco Industrial do Brasil S.A."
    },
    {
      "codBanco": "610",
      "banco": "Banco VR S.A."
    },
    {
      "codBanco": "611",
      "banco": "Banco Paulista S.A."
    },
    {
      "codBanco": "612",
      "banco": "Banco Guanabara S.A."
    },
    {
      "codBanco": "613",
      "banco": "Omni Banco S.A."
    },
    {
      "codBanco": "623",
      "banco": "Banco Pan S.A."
    },
    {
      "codBanco": "626",
      "banco": "Banco Ficsa S. A."
    },
    {
      "codBanco": "630",
      "banco": "Banco Intercap S.A."
    },
    {
      "codBanco": "633",
      "banco": "Banco Rendimento S.A."
    },
    {
      "codBanco": "634",
      "banco": "Banco Triângulo S.A."
    },
    {
      "codBanco": "637",
      "banco": "Banco Sofisa S. A."
    },
    {
      "codBanco": "641",
      "banco": "Banco Alvorada S.A."
    },
    {
      "codBanco": "643",
      "banco": "Banco Pine S.A."
    },
    {
      "codBanco": "652",
      "banco": "Itaú Unibanco Holding S.A."
    },
    {
      "codBanco": "653",
      "banco": "Banco Indusval S. A."
    },
    {
      "codBanco": "654",
      "banco": "Banco A. J. Renner S.A."
    },
    {
      "codBanco": "655",
      "banco": "Banco Votorantim S.A."
    },
    {
      "codBanco": "707",
      "banco": "Banco Daycoval S.A."
    },
    {
      "codBanco": "712",
      "banco": "Banco Ourinvest S.A."
    },
    {
      "codBanco": "719",
      "banco": "Banif - Bco Internacional do Funchal (Brasil) S.A."
    },
    {
      "codBanco": "735",
      "banco": "Banco Neon S.A."
    },
    {
      "codBanco": "739",
      "banco": "Banco Cetelem S.A."
    },
    {
      "codBanco": "741",
      "banco": "Banco Ribeirão Preto S.A."
    },
    {
      "codBanco": "743",
      "banco": "Banco Semear S.A."
    },
    {
      "codBanco": "745",
      "banco": "Banco Citibank S.A."
    },
    {
      "codBanco": "746",
      "banco": "Banco Modal S.A."
    },
    {
      "codBanco": "747",
      "banco": "Banco Rabobank International Brasil S.A."
    },
    {
      "codBanco": "748",
      "banco": "Banco Cooperativo Sicredi S. A."
    },
    {
      "codBanco": "751",
      "banco": "Scotiabank Brasil S.A. Banco Múltiplo"
    },
    {
      "codBanco": "752",
      "banco": "Banco BNP Paribas Brasil S.A."
    },
    {
      "codBanco": "753",
      "banco": "Novo Banco Continental S.A. - Banco Múltiplo"
    },
    {
      "codBanco": "754",
      "banco": "Banco Sistema S.A."
    },
    {
      "codBanco": "755",
      "banco": "Bank of America Merrill Lynch Banco Múltiplo S.A."
    },
    {
      "codBanco": "756",
      "banco": "Banco Cooperativo do Brasil S/A - Bancoob"
    },
    {
      "codBanco": "757",
      "banco": "Banco Keb Hana do Brasil S. A."
    }
  ]